<template>
  <v-container style="margin-top:60px;background: #1e1e1e;" dark>
    <v-dialog
        v-model="edit_video"
        max-width="800"
    >

        <v-card :disabled="youtube_loading" :loading="youtube_loading?'green':false"               class="pa-4"
        >
          <v-card-title>
            <span class="text-h5">Videoförslag</span>
            <v-spacer></v-spacer>
            <v-btn @click="remove_video" icon><v-icon>mdi-delete</v-icon></v-btn>
          </v-card-title>
          <v-text-field
              append-icon="mdi-youtube"
              dense
              style="margin-top:8px;"
              label="Youtube-länk"
              outlined
              v-model="youtube_link"

          ></v-text-field>
          <v-row style="width:100%;">
            <v-col cols="4">
              <v-img
                  style="height:150px;width:150px;border-radius: 4px; margin-top: -12px;"
                  :src="youtube_video.image"
              >

              </v-img>
            </v-col>
            <v-col cols="8" >

              <span v-if="youtube_video.title!==''">
                                                      <v-card-title class="text-truncate d-inline-block" style="font-size:18px;display:block;width:100%;"><i>{{youtube_video.title}}</i></v-card-title>

                <v-row  style="margin-top:-4px;">
                                    <v-col cols="4">
                                      <v-text-field
                                          dense
                                          label="Börja vid"
                                          outlined
                                          suffix="s"
                                          v-model="examples[video_selected].start_at"
                                          type="number"
                                          class="hide_my_spin"

                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="8">
                                      <v-checkbox
                                          v-model="examples[video_selected].sound_only"
                                          color="success"
                                          label="Spela endast ljud"
                                          style="margin-bottom:-20px;margin-left:-4px !important;margin-top:2px;"

                                      >


                                      </v-checkbox>

                                    </v-col>

                                  </v-row>
                                                    </span>

              <span v-else-if="youtube_video.title===''">
                                                      <v-card-title class="text-truncate d-inline-block" style="font-size:18px;display:block;width:100%;text-align: center;"><i>Klistra in Youtube-länk</i></v-card-title>
                                                    </span>

            </v-col>
          </v-row>

          <v-card-actions>
            <v-btn
                block
                dark
                @click="save_video"
                color="green"
            >
              Spara
            </v-btn>
          </v-card-actions>


        </v-card>

    </v-dialog>
    <v-card flat dark>

      <v-row dark justify="center">
        <v-col class="col-8 col-md-5 col-lg-3" cols="6">
          <v-checkbox
              v-model="is_enabled"
          >
                  <span slot="label">
                    <span style="font-size:20px;"
                          :style="{'color':is_enabled?'#08d30e':'gray'}"><b>{{ is_enabled ? 'Aktiv' : 'Inaktiv' }}</b></span>
                    <br>
                    Med denna overlay kan dina tittare genom donationer spela upp Youtube-klipp
                  </span>


          </v-checkbox>
        </v-col>


      </v-row>
      <v-row class="mx-auto"  justify="center" style="background:#111111;border-radius: 10px;max-width:700px;padding:20px;">
        <v-col align="center" class="col-12">
          <v-text-field

              type="password"
              :value="url"
              outlined
              label="Browser-länk"
              dense
              :disabled="!is_enabled"

              readonly

              hide-details
          >

            <v-btn small v-clipboard:copy="url" slot="append" icon>
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </v-text-field>
          <v-card
              flat
              tile
              color="transparent"
              class="white--text text-center"
          >
            <v-card-text style="padding-top: 8px;">
              Använd denna länk som <i>Browser Source</i> i ditt OBS.

            </v-card-text>
          </v-card>
        </v-col>
        <v-col align="center"  class="col-12">
          <v-slider

              v-model="price_per_second"
              class="align-center"
              :max="10"
              step="0.1"
              :min="0.1"
              :disabled="!is_enabled"
              label="Pris per sekund"
              hide-details
          >
            <template v-slot:append>
              <v-text-field
                  v-model="price_per_second"
                  class="mt-0 pt-0"
                  hide-details
                  :disabled="!is_enabled"

                  single-line

                  suffix="KR"
                  type="number"
                  style="width: 60px"
              ></v-text-field>
            </template>
          </v-slider>
          <v-card
              color="transparent"

              flat
              tile
              class="white--text text-center"
          >
            <v-card-text style="padding-top: 8px;">
              <i>Exempel:</i> 30 sekunder kostar {{ Math.ceil(price_per_second * 30) }} kr

            </v-card-text>
          </v-card>
        </v-col>
        <v-col align="center"  class="col-12">
          <v-slider
              v-model="number_of_views"
              class="align-center"
              :max="3"
              step="1"
              :min="0"
              :disabled="!is_enabled"
              :tick-labels="['Avstängd','Låg','Medel','Mod']"
              label="Säkerhet"
          >

          </v-slider>
          <v-card
              flat
              tile
              color="transparent"

              class="white--text text-center"
          >
            <v-card-text style="padding-top: 8px;">
               {{video_requirements[number_of_views]}}

            </v-card-text>
          </v-card>
        </v-col>
        <v-col v-if="number_of_views===3" align="center" class="col-12">
          <v-text-field

              type="password"
              :value="url+'&mod=1'"
              outlined
              label="Moderator-länk"
              dense
              :disabled="!is_enabled"

              readonly

              hide-details
          >

            <v-btn small v-clipboard:copy="url+'&mod=1'" slot="append" icon>
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </v-text-field>
          <v-card
              flat
              tile
              color="transparent"
              class="white--text text-center"
          >
            <v-card-text style="padding-top: 8px;">
              Moderatorer kan använda denna länk för att godkänna och neka klipp

            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col style="margin-top:80px;" align="center" justify="center" cols="12">
          <v-btn  @click="create_video" color="green" dark>
            <v-icon>mdi-plus</v-icon> Skapa videoförslag

          </v-btn>
          <br>
          <small>(Endast förslag, tittare kan bestämma själva)</small>

          <v-tabs
              centered
              dark
              next-icon="mdi-arrow-right-bold-box-outline"
              prev-icon="mdi-arrow-left-bold-box-outline"
              show-arrows
              height="100"
              v-model="video_selected"


          >




            <v-tab
                :disabled="!is_enabled"
                v-for="(video,index) in examples"
                :key="index"


            >

              <v-img
                  v-if="video.id!=='unknown'"
                  style="height:100px;width:100px;border-radius:4px;"
                  :src="`https://i.ytimg.com/vi/${video.id}/hqdefault.jpg`"
                  eager
              >

                <v-btn
                    style="width:100%;height:100%;"
                    @click="edit_video=true"
                    class="shadowed" v-show="video_selected===index" large

                    icon
                >
                  <v-icon>
                    mdi-pencil
                  </v-icon>
                </v-btn>

              </v-img>
              <v-img
                  v-else
                  style="height:100px;width:100px;border-radius:4px;"
                  :src="`https://i.ytimg.com/vi/${video.id}/hqdefault.jpg`"
              >

                <v-btn
                    style="width:100%;height:100%;"
                    @click="edit_video=true"
                    class="shadowed"  large

                    icon
                >
                  <v-icon>
                    mdi-plus
                  </v-icon>
                </v-btn>

              </v-img>
            </v-tab>
          </v-tabs>


        </v-col>
      </v-row>


      <v-row>
        <v-col style="margin-bottom:-40px;" class="col-12">
          <v-card
              flat
              dark
              tile
              class="white--text text-center"
          >

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="videoTest" color="green" :disabled="!is_enabled">
                Skicka testvideo (5 sekunder)
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>

          </v-card>


        </v-col>
        <v-col class="col-0 col-md-0 col-lg-3 d-none d-lg-block"></v-col>
      </v-row>
    </v-card>
    <v-responsive v-if="url!==''" class="mx-auto" style="max-width:40vw;max-height:40vh;" :aspect-ratio="16/9">
      <iframe :src=url></iframe>
    </v-responsive>


  </v-container>
</template>

<script>

export default {
  name: "VideoOverlay",
  components: {},
  data() {
    return {
      video_requirements:[
        "Alla klipp kan spelas",
        "1 000+ visningar krävs",
        "50 000+ visningar krävs",
        "Mod behöver godkänna klipp",
      ],
      number_of_views:0,
      just_loaded:true,
      save_timeout:null,
      force_key:0,
      youtube_loading:false,
      youtube_link:"",
      edit_video:false,
      video_selected: 0,
      examples: [
      ],
      is_enabled: false,
      price_per_second: 0,
      hash:"",
      youtube_video:{
        image:"https://i.ytimg.com/vi/unknown/hqdefault.jpg",
        title:"",
        views:0
      },
      youtube_link_check:null

    }
  },
  computed: {
    url: function () {
      if(this.hash!==""){
        return window.location.origin + "/widget_vi?id=" + this.hash;
      }else{
        return "";

      }
    }
  },
  methods: {

    save_video:function(){
      this.edit_video=false;
      this.update_overlay();
    },

    create_video:function(){
      this.examples.unshift({
        id: "",
        link: "",
        start_at:0,
        sound_only:false
      });
      this.youtube_link="";
      this.video_selected=0;
      this.edit_video=true;


    },

    remove_video:function(){
      this.edit_video=false;

      this.examples.splice(this.video_selected, 1);
      this.update_overlay();

    },

    get_overlay_info:function(){
      let http = new XMLHttpRequest();
      let url = '/api/overlay_info';
      http.open('GET', url, true);
      let self=this;
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

      http.onreadystatechange = function() {

        if(http.readyState === 4 && http.status === 200){
          let resp=JSON.parse(http.responseText);
          self.hash=resp.HASH;
          self.is_enabled=resp.ENABLED===1;
          let setup=JSON.parse(resp.SETUP)
          self.examples=setup.examples;
          self.price_per_second=setup.price_per_second;
          self.number_of_views=setup.number_of_views;
          if(self.examples.length>0){
            self.youtube_link=self.examples[0].link;

          }
        }

      };
      http.send();
    },


    update_overlay:function(){
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let self=this;
      let url = '/api/update_overlay?';
      http.open('POST', url, true);
      http.setRequestHeader('Content-type', 'application/json');
      http.onreadystatechange = function() {
        if(http.readyState === 4) {
          if(http.status!==200){
            self.$store.commit("update_snackbar","Ett fel inträffade");
          }

        }
      };
      if(!this.just_loaded){
        http.send(JSON.stringify({
          examples:this.examples,
          is_enabled:this.is_enabled?1:0,
          price_per_second:this.price_per_second,
          number_of_views:this.number_of_views
        }));
      }else{
        this.just_loaded=false;
      }


    },

    get_youtube_info:function(){

      var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      var match = this.youtube_link.match(regExp);
      let youtube_id=null;
      if (match && match[2].length === 11) {
        youtube_id=match[2];
      }
      if(youtube_id!==null){
        this.examples[this.video_selected].link=this.youtube_link;
        this.examples[this.video_selected].id=youtube_id;

        this.force_key+=1;
        let http = new XMLHttpRequest();
        let url = '/api/video_info?video_id='+youtube_id;
        http.open('GET', url, true);
        let self=this;
        http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

        http.onreadystatechange = function() {

          if(http.readyState === 4 && http.status === 200){
            self.youtube_loading=false;
            let video_info=JSON.parse(http.response);
            if("error" in video_info){
              self.youtube_video={
                image:"https://i.ytimg.com/vi/unknown/hqdefault.jpg",
                title:"",
                views:0
              }
            }
            else if(video_info.items.length===0){
              self.youtube_video={
                image:"https://i.ytimg.com/vi/unknown/hqdefault.jpg",
                title:"",
                views:0
              }
            }else{
              self.youtube_video={
                image:video_info.items[0].snippet.thumbnails.medium.url,
                title:video_info.items[0].snippet.title,
                views:video_info.items[0].statistics.viewCount

              }
            }
          }
          else if(http.readyState === 4 && http.status === 200){
            self.youtube_loading=false;

          }

          };
        http.send();
      }else{
        this.youtube_loading=false;
        this.youtube_link=""

        this.examples[this.video_selected].link=""
        this.examples[this.video_selected].id="unknown"
      }


    },

    videoTest: function () {
      let http = new XMLHttpRequest();
      let opacity=this.examples[this.video_selected].sound_only?0:1;
      let url = '/api/test_video?id='+this.examples[this.video_selected].id+'&start='+this.examples[this.video_selected].start_at+'&opacity='+opacity+'&price_per_second='+this.price_per_second;
      http.open('GET', url, true);
      let self = this;
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      http.onreadystatechange = function () {
        if (http.readyState === 4 && http.status === 200) {
          self.$store.commit("update_snackbar", "Video-test skickat!");
        }

      }
      http.send();
    },


  },
  watch:{

    edit_video:function(){

      if(this.examples[this.video_selected].id==="" && !this.edit_video){
        this.examples.splice(this.video_selected, 1);
      }
    },

    number_of_views:function(){
      let self=this;
      clearTimeout(this.save_timeout);
      this.save_timeout=setTimeout(function(){
        self.update_overlay();
      },300);
    },

    price_per_second:function(){
      let self=this;
      clearTimeout(this.save_timeout);
      this.save_timeout=setTimeout(function(){
        self.update_overlay();
      },300);
    },
    is_enabled:function(){
      let self=this;
      clearTimeout(this.save_timeout);
      this.save_timeout=setTimeout(function(){
        self.update_overlay();
      },100);
    },




    video_selected:function(){
      this.youtube_link=this.examples[this.video_selected].link;

    },

    youtube_link:function(){

      if(this.youtube_link!==""){
        this.youtube_loading=true;
      }else{
        this.video_selected=0;
        this.youtube_video={
          image:"https://i.ytimg.com/vi/unknown/hqdefault.jpg",
          title:"",
          views:0
        }
      }
      clearTimeout(this.youtube_link_check);
      let self=this;
      this.youtube_link_check=setTimeout(function(){
        self.get_youtube_info();
      },500);
    },
  },
  mounted: function () {
    document.title = "Hihat - Overlays";
    this.get_overlay_info();

  }

}
</script>

<style scoped>
iframe {
  width: 100%;
  height: 100%;
}

.shadowed {
  color: rgb(255 255 255);
  text-shadow: 2px 2px 2px black;
}

</style>
